import React, { useEffect, useState } from 'react';

interface GamePlayerPortraitProps {
  name: string;
  position: string;
  url?: string;
  className?: string;
}

const GamePlayerPortrait: React.FC<GamePlayerPortraitProps> = ({ name, position, url, className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [url]);

  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('');

  return (
    <span className={`game-player-portrait ${className}`} aria-hidden="true">
      {url && !failed ? (
        <img src={url} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      ) : (
        <span>{initials || position}</span>
      )}
    </span>
  );
};

export default GamePlayerPortrait;
